import { render, staticRenderFns } from "./InputSimple.vue?vue&type=template&id=4598f3fb&scoped=true"
import script from "./InputSimple.vue?vue&type=script&lang=js"
export * from "./InputSimple.vue?vue&type=script&lang=js"
import style0 from "./InputSimple.vue?vue&type=style&index=0&id=4598f3fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4598f3fb",
  null
  
)

export default component.exports